import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { initPixel, initAxon, trackPageView } from "@/lib/analytics";

/**
 * Loads the META_PIXEL_ID + APPLOVIN_PIXEL_KEY from the backend once, then
 * fires PageView on every client-side route change. Mount once at app root.
 */
export default function useMetaPixel() {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/config");
        if (cancelled) return;
        if (data?.meta_pixel_id) initPixel(data.meta_pixel_id);
        if (data?.applovin_pixel_key) initAxon(data.applovin_pixel_key);
        // Do NOT fire PageView here — the pathname effect below covers the
        // initial route as well as subsequent client-side navigations.
      } catch (_) { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    trackPageView();
  }, [location.pathname]);
}
